// Quick-pick languages offered during onboarding for the brand's default post
// language. Free text is always allowed too, so this is just a convenience list
// of common choices — not an allow-list.
export const LANGUAGE_SUGGESTIONS = [
  'English',
  'Deutsch',
  'Español',
  'Français',
  'Italiano',
  'Nederlands',
]
